var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoConnection = function SvgNoConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 32,
    fill: "#FFB42C",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.796 32.037a1.833 1.833 0 0 0-2.592 2.593l6.835 6.835a24.117 24.117 0 0 0-4.905 3.326 1.833 1.833 0 1 0 2.413 2.761 20.416 20.416 0 0 1 5.244-3.335l2.836 2.836a14.743 14.743 0 0 0-5.073 3.31 1.833 1.833 0 1 0 2.575 2.61 11.078 11.078 0 0 1 5.429-2.99l3.76 3.76a3.667 3.667 0 1 0 2.105 2.105l8.114 8.115a1.833 1.833 0 1 0 2.593-2.593L32.796 32.037ZM44.922 39.03l3.475 3.474a20.39 20.39 0 0 1 13.056 5.048 1.833 1.833 0 1 0 2.413-2.761 24.08 24.08 0 0 0-18.944-5.761ZM52.704 46.812l5.945 5.944c.22-.302.351-.675.351-1.079 0-.506-.205-.964-.537-1.296a14.737 14.737 0 0 0-5.759-3.57Z",
    fill: "#BC8E39"
  })));
};
export default SvgNoConnection;